import { render, staticRenderFns } from "./SalesFilters.vue?vue&type=template&id=3dca0cd4&scoped=true&"
import script from "./SalesFilters.vue?vue&type=script&lang=js&"
export * from "./SalesFilters.vue?vue&type=script&lang=js&"
import style0 from "./SalesFilters.vue?vue&type=style&index=0&id=3dca0cd4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dca0cd4",
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QIcon,QPopupProxy,QDate,QBtn});qInstall(component, 'directives', {ClosePopup});
